/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_IMG,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {
    FormatListBulletedOutlined,
    GroupsOutlined,
    ManageSearch,
    PeopleOutline,
    TaskOutlined
} from "@mui/icons-material";
import {ESTADOSCUENTA} from "../../Constantes";
import Dialogo_Usuario from "../Dialogos/Dialogo_Usuario";
import {useNavigate} from "react-router";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import Dialogo_Usuario_Padres from "../Dialogos/Dialogo_Usuario_Padres";


const Seccion_Usuarios = () => {
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(false);
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'cuentas'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Usuario,
        titulo: 'Detalles del usuario',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPadre, abrir: abrirPadres} = useDialogo({
        Componente: Dialogo_Usuario_Padres,
        titulo: 'Detalles del usuario',
        realizado: cargarNuevamente
    })

    const funcionBuscar = async (correo) => {

        if (correo) {
            setCargando(true);
            let w = [where('correo', '==', correo)]
            let dox = await obtenerColWheres({col: 'cuentas', wheres: w})
            setData([])
            if (dox.data) {
                setData(dox.data)
            }
            setCargando(false)
        }

    }

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'padres':
                abrirPadres(data)
                break
            case 'hijos':
                navigate('/EquipoID/' + data.id)
                break
            case 'contratos':
                navigate('/ContratosID/idUsuario/' + data.id)
                break
            case 'movimientos':
                navigate('/UsuarioMovID/' + data.id)
                break
            default :
                abrir(data)
        }
    }

    //UsuarioMovID

    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoPadre/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de usuarios'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                   //     clickAgregar={abrir}
                        botonesData={botonesData}
                        cargando={cargando}
                        clickData={click}
                        funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Usuarios

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        tipo: CASILLA_IMG,
        size: 60
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Correo',
        direccion: 'left',
        propiedad: 'correo',
        fecha: 'fechaMembresia',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Codigo',
        direccion: 'left',
        propiedad: 'minHash',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSCUENTA
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Padres',
        id: 'padres',
        icono: PeopleOutline
    },
    {
        nombre: 'Hijos',
        id: 'hijos',
        icono: GroupsOutlined
    },
    {
        nombre: 'Contratos',
        id: 'contratos',
        icono: TaskOutlined
    },
    {
        nombre: 'Movimientos',
        id: 'movimientos',
        icono: FormatListBulletedOutlined
    },
]